import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md text-center">
        <XCircle className="w-10 h-10 mx-auto mb-6 text-white/50" />
        <div className="label-eyebrow mb-3">payment cancelled</div>
        <h1 className="font-display text-3xl font-black tracking-tight mb-3">
          No charge was made.
        </h1>
        <p className="text-white/60 text-[14px] mb-10">
          You closed the checkout window before completing the purchase.
        </p>
        <div className="flex gap-3 justify-center">
          <button onClick={() => nav("/pricing")} className="btn-pill focus-ring" data-testid="return-to-pricing">
            Back to plans
          </button>
          <button onClick={() => nav("/")} className="btn-ghost focus-ring">
            Home
          </button>
        </div>
      </div>
    </div>
  );
}
